module.exports = __webpack_public_path__ + "static/media/icon-check-white.63d637c7.svg";